import { useEffect, useState } from 'react';
import { usePortfolioQuery } from '../application/getPortfolio.query';
import { useReveal } from '../../../shared/lib/useReveal';
import { Preloader } from '../../../shared/ui';
import { Nav } from './Nav';
import { Hero } from './Hero';
import { About } from './About';
import { Skills } from './Skills';
import { Projects } from './Projects';
import { ExpEdu } from './ExpEdu';
import { Services } from './Services';
import { Testimonials } from './Testimonials';
import { Blog } from './Blog';
import { Contact } from './Contact';
import { Footer } from './Footer';

export function PortfolioView() {
  const { data, error } = usePortfolioQuery();
  const [theme, setTheme] = useState(() => {
    return (typeof localStorage !== 'undefined' && localStorage.getItem('portfolio-theme')) || 'dark';
  });

  useReveal(data);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    document.documentElement.removeAttribute('data-vibe');
    try { localStorage.setItem('portfolio-theme', theme); } catch (e) {}
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'));

  if (error) {
    return <div>Error loading portfolio data</div>;
  }

  return (
    <>
      <Preloader isDataLoaded={!!data} />
      {data && (
        <>
          <div className="bg-fx" />
          <div className="bg-scanlines" />
          <div className="bg-noise" />
          <div className="shell">
            <Nav theme={theme} onToggleTheme={toggleTheme} />
            <Hero data={data} />
        <About data={data} />
        <Skills data={data} />
        <ExpEdu data={data} />
        <Projects data={data} />
        <Services data={data} />
        <Testimonials data={data} />
        <Blog data={data} />
        <Contact data={data} />
        <Footer data={data} />
      </div>
        </>
      )}
    </>
  );
}
